import { VariableRequiredError } from '../exceptions/variable-required-error';

import type { TParams, TTemplate } from './create-template';
import { createTemplate } from './create-template';

/** Объект/функция переменной окружения */
export type TEnvVar<P extends TParams> = TTemplate<P> & {
    /** Исходное значение переменной окружения */
    value(): string | undefined;
};

/**
 * Создать объект переменной окружения
 * @param envVarName Название переменной
 * @param envVarValue Значение переменной
 * @param interpolate Регулярное выражение интерполяции (по умолчанию: `/{([\S\s]+?)}/g`)
 * @example
 * const ENV_WEBINAR_LIST = '//alfabank.ru/webinar/{sessionId}/list?order={order}';
 * const envVar = createEnvVar('ENV_WEBINAR_LIST', ENV_WEBINAR_LIST);
 * // usage
 * envVar({ sessionId: '__session123__', order: 'desc' }); // '//alfabank.ru/api/v1/webinar/__session123__/list?order=desc'
 * envVar({ order: 'desc' }); // '//alfabank.ru/api/v1/webinar/{sessionId}/list?order=desc'
 * envVar(); // '//alfabank.ru/api/v1/webinar/{sessionId}/list?order={order}'
 * envVar.value(); // '//alfabank.ru/api/v1/webinar/{sessionId}/list?order={order}'
 */
export const createEnvVar = <P extends TParams = undefined>(
    envVarName: string,
    envVarValue?: string,
    interpolate?: RegExp
) => {
    let template: TTemplate<P>;

    const envVar: TEnvVar<P> = params => {
        if (!envVarValue) throw new VariableRequiredError(envVarName);

        if (!template) template = createTemplate<P>(envVarValue, interpolate);

        return template(params);
    };

    envVar.value = () => envVarValue;

    return envVar;
};
